import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Table,
	Row,
	Col,
	Button,
	Form,
	Tag,
	notification,
	Select,
	Modal,
} from "antd";
import Layout from "../layout/Layout";
import { CustomSearch, CustomSpinner } from "../utils/CustomComponents";
import { PlusCircleOutlined, UnorderedListOutlined } from "@ant-design/icons";
import CreateCustomerTask from "./CreateCustomerTask";
import { rankingOptions2 } from "../../constants/Customer";
import { Link } from "react-router-dom";
import ShowFollowUpData from "./ShowFollowUpData";
const { Text } = Typography;

const FollowUpDashboard = () => {
	const [loading, setLoading] = useState(true);
	const [loadingTable, setLoadingTable] = useState(false);
	const [list, setList] = useState([]);
	const [sellerList, setSellerList] = useState([]);
	const [seller, setSeller] = useState(null);
	const [modalTaskOpen, setModalTaskOpen] = useState(false);
	const [modalDataOpen, setModalDataOpen] = useState(false);
	const [sellerDisabled, setSellerDisabled] = useState(false);
	const [ranking, setRanking] = useState("All");
	const followUpData = useRef([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getSellerList();
	}, []);

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "Customer",
			dataIndex: "customer",
			key: "customer",
			render: (value, values) => {
				return <Link to={`/client/${values.id}`}>{value}</Link>;
			},
		},
		{
			title: "Ranking",
			dataIndex: "ranking",
			key: "ranking",
			render: (value) => {
				let color = "";
				switch (value) {
					case "A":
						color = "purple";
						break;
					case "B":
						color = "blue";
						break;
					case "C":
						color = "green";
						break;
					case "D":
						color = "red";
						break;
					default:
						color = "default";
						break;
				}
				return <Tag color={color}>{value || "None"}</Tag>;
			},
		},
		{
			title: "Last Pour",
			dataIndex: "lastPour",
			key: "lastPour",
			render: (value) => {
				if (!value) return <Tag color="default">None</Tag>;

				const givenDate = new Date(value);
				const now = new Date();

				const diffInMs = now - givenDate;
				const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
				const diffInMonths = diffInDays / 30;

				let color = "";

				switch (true) {
					case diffInMonths < 1:
						color = "green";
						break;
					case diffInMonths < 2:
						color = "orange";
						break;
					default:
						color = "red";
						break;
				}

				const formatDate = new Intl.DateTimeFormat("en-US", {
					month: "numeric",
					year: "numeric",
					day: "numeric",
					hour: "2-digit",
					minute: "2-digit",
					second: "2-digit",
				}).format(new Date(value));

				return <Tag color={color}>{formatDate}</Tag>;
			},
		},
		{
			title: "Follow-Up 1 (Current Week)",
			dataIndex: "followUp1",
			key: "followUp1",
			render: (value) => {
				if (value && value.length > 0) {
					return (
						<Button
							type="primary"
							onClick={() => {
								followUpData.current = value;
								setModalDataOpen(true);
							}}
							icon={<UnorderedListOutlined />}
						/>
					);
				}
				return <Text>-</Text>;
			},
		},
		{
			title: "Follow-Up 2 (Last Week)",
			dataIndex: "followUp2",
			key: "followUp2",
			render: (value) => {
				if (value && value.length > 0) {
					return (
						<Button
							type="primary"
							onClick={() => {
								followUpData.current = value;
								setModalDataOpen(true);
							}}
							icon={<UnorderedListOutlined />}
						/>
					);
				}
				return <Text>-</Text>;
			},
		},
		{
			title: "Follow-Up 3 (2 Weeks Apart)",
			dataIndex: "followUp3",
			key: "followUp3",
			render: (value) => {
				if (value && value.length > 0) {
					return (
						<Button
							type="primary"
							onClick={() => {
								followUpData.current = value;
								setModalDataOpen(true);
							}}
							icon={<UnorderedListOutlined />}
						/>
					);
				}
				return <Text>-</Text>;
			},
		},
		{
			title: "Follow-Up 4 (3 Weeks Apart)",
			dataIndex: "followUp4",
			key: "followUp4",
			render: (value) => {
				if (value && value.length > 0) {
					return (
						<Button
							type="primary"
							onClick={() => {
								followUpData.current = value;
								setModalDataOpen(true);
							}}
							icon={<UnorderedListOutlined />}
						/>
					);
				}
				return <Text>-</Text>;
			},
		},
		{
			title: "Follow-Up 5 (4 Weeks Apart)",
			dataIndex: "followUp5",
			key: "followUp5",
			render: (value) => {
				if (value && value.length > 0) {
					return (
						<Button
							type="primary"
							onClick={() => {
								followUpData.current = value;
								setModalDataOpen(true);
							}}
							icon={<UnorderedListOutlined />}
						/>
					);
				}
				return <Text>-</Text>;
			},
		},
		{
			title: "Seller",
			dataIndex: "seller",
			key: "seller",
			editable: true,
		},
	];

	const EditableCell = ({
		editMode,
		dataIndex,
		record,
		title,
		handleSave,
		children,
		sellerList,
		...restProps
	}) => {
		const [form] = Form.useForm();

		const onSaveSelect = (value) => {
			handleSave(
				{
					...record,
					[dataIndex]: value,
				},
				dataIndex,
			);
		};

		const email = localStorage.getItem("email");

		return (
			<td {...restProps}>
				{editMode ? (
					<Form form={form} initialValues={{ [dataIndex]: record[dataIndex] }}>
						<Form.Item
							style={{ margin: 0 }}
							name={dataIndex}
							rules={[{ required: false }]}
						>
							<Select
								style={{ width: "100%" }}
								value={record[dataIndex]}
								options={sellerList}
								disabled={
									email !== "eliud@gmail.com" &&
									email !== "ec@57concrete.com" &&
									email !== "pc@57concrete.com" &&
									email !== "jc@57concrete.com" &&
									email !== "gg@57xgroup.com" &&
									email !== "rl@57concrete.com" &&
									email !== "jh@57concrete.com" &&
									email !== "bpa@57concrete.com"
								}
								onChange={onSaveSelect}
								allowClear={false}
							/>
						</Form.Item>
					</Form>
				) : (
					children
				)}
			</td>
		);
	};

	const handleSave = async (updatedCustomer, field) => {
		await updateCustomer(updatedCustomer, field);
		const updatedList = list.map((item) => {
			if (item.key !== updatedCustomer.key) return item;
			return updatedCustomer;
		});
		setList(updatedList);
	};

	const updateCustomer = async (customer, field) => {
		setLoadingTable(true);
		const url = api + `/customer/update/prospection/${customer.id}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		let body = {};

		if (field === "seller")
			body = {
				prospectionSeller: customer.seller,
			};

		try {
			const { data } = await axios.patch(url, body);
			if (data.success) {
				setLoadingTable(false);
				if (field === "seller") {
					getCustomerList();
				}
			} else {
				setLoadingTable(true);
			}
		} catch (err) {
			setLoadingTable(false);
			console.error(err.message);
			return null;
		}
	};

	const mergedColumns = columns.map((col) => {
		if (!col.editable) {
			return col;
		}
		return {
			...col,
			onCell: (record) => ({
				record,
				editMode: true,
				dataIndex: col.dataIndex,
				title: col.title,
				handleSave: handleSave,
			}),
		};
	});

	const getSellerList = async () => {
		setLoading(true);

		const url = api + "/user/list/57Concrete/Seller";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						value: item._id,
						label: item.name,
					});
				});
				setSellerList(list);
				const currentSeller = list.find(
					(seller) => seller.value === localStorage.getItem("userId"),
				);
				if (currentSeller) {
					setSeller(currentSeller.value);
				}
				const email = localStorage.getItem("email");

				if (
					email === "eliud@gmail.com" ||
					email === "ec@57concrete.com" ||
					email === "jc@57concrete.com" ||
					email === "pc@57concrete.com" ||
					email === "gg@57xgroup.com" ||
					email === "rl@57concrete.com" ||
					email === "jh@57concrete.com" ||
					email === "bpa@57concrete.com"
				) {
					setSellerDisabled(false);
				} else {
					setSellerDisabled(true);
				}
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	useEffect(() => {
		if (seller && ranking) {
			getCustomerList();
		}
	}, [seller, ranking]);

	const getCustomerList = async () => {
		setLoading(true);

		const url =
			api + `/customer/list/regular/byseller/${seller}?ranking=${ranking}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item, index) => {
					const sortedWeeks = Object.entries(item.tasksByWeek).sort(
						([a], [b]) => new Date(b) - new Date(a),
					);

					list.push({
						key: index,
						id: item._id,
						customer: `${item.customerNumber} ${item.name}`,
						ranking: item.ranking || "C",
						lastPour: item.job ? item.job.scheduledDate : null,
						seller: item.prospectionSeller._id,
						followUp1: sortedWeeks[0]?.[1] || [],
						followUp2: sortedWeeks[1]?.[1] || [],
						followUp3: sortedWeeks[2]?.[1] || [],
						followUp4: sortedWeeks[3]?.[1] || [],
						followUp5: sortedWeeks[4]?.[1] || [],
					});
				});
				setList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				<Table
					columns={mergedColumns}
					dataSource={list}
					components={{
						body: {
							cell: (props) => (
								<EditableCell {...props} sellerList={sellerList} />
							),
						},
					}}
					pagination={{
						position: ["bottomRight"],
						pageSizeOptions: [10, 20, 50, 100],
						defaultPageSize: 10,
						showSizeChanger: true,
					}}
					scroll={{
						x: true,
					}}
					style={{
						minWidth: "100%",
					}}
					loading={loadingTable}
				/>
			</Flex>
		);
	};

	const onChangeSeller = (value) => {
		setSeller(value);
		if (!value) {
			setList([]);
		}
	};

	const onChangeRanking = (value) => {
		setRanking(value);
	};

	const RenderSellers = () => {
		return (
			<Flex gap={"large"} align={"center"} justify="space-between">
				<CustomSearch
					loading={loading}
					allowClearPicker={true}
					labelPicker={"Seller"}
					optionsPicker={sellerList}
					pickerWidth={"300px"}
					pickerValue={seller}
					onChangePicker={onChangeSeller}
					disabledPicker={sellerDisabled}
					allowClearPicker2={false}
					labelPicker2={"Ranking"}
					optionsPicker2={rankingOptions2}
					pickerWidth2={"300px"}
					pickerValue2={ranking}
					onChangePicker2={onChangeRanking}
					disabledPicker2={!seller}
				/>

				<Button
					type="dashed"
					htmlType="button"
					size="large"
					icon={<PlusCircleOutlined />}
					onClick={() => setModalTaskOpen(true)}
					disabled={!seller}
				>
					Add Task
				</Button>
			</Flex>
		);
	};

	const onTaskCreated = () => {
		setModalTaskOpen(false);
		getCustomerList();
	};

	const ModalTask = () => {
		return (
			<Modal
				title="New Task"
				open={modalTaskOpen}
				onCancel={() => setModalTaskOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<CreateCustomerTask
					from={"followup"}
					seller={seller}
					onCreated={onTaskCreated}
				/>
			</Modal>
		);
	};

	const ModalViewData = () => {
		return (
			<Modal
				title="Follow Up Data"
				open={modalDataOpen}
				onCancel={() => setModalDataOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
			>
				<ShowFollowUpData data={followUpData.current} />
			</Modal>
		);
	};

	return (
		<Layout title="Follow Up" description="Dashboard" type="large">
			<Flex vertical gap={"large"}>
				<RenderSellers />
				{loading ? <CustomSpinner /> : <RenderTable />}
			</Flex>
			{contextHolder}
			<ModalTask />
			<ModalViewData />
		</Layout>
	);
};

export default FollowUpDashboard;
